<template>
  <v-container fluid class="pa-2 pa-sm-4">
    <div class="text-h6 font-weight-bold mb-2" style="color: #0E314A">
      Painel Administrativo
    </div>

    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-card-text class="pa-3">
            <div class="text-caption text-uppercase grey--text">Licenças</div>
            <div class="text-h5 font-weight-bold" style="color: #0E314A">
              {{ dados.qtd_ativos }}
              <span class="text-body-1 font-weight-regular grey--text">/ {{ dados.licencas }}</span>
            </div>
            <div class="text-caption grey--text">usuários ativos / total</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-card-text class="pa-3">
            <div class="text-caption text-uppercase grey--text">Acessos Hoje</div>
            <div class="text-h5 font-weight-bold" style="color: #0E314A">
              {{ dados.acessos_hoje }}
            </div>
            <div class="text-caption grey--text">logins realizados hoje</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-card-text class="pa-3">
            <div class="text-caption text-uppercase grey--text">Média Diária (30d)</div>
            <div class="text-h5 font-weight-bold" style="color: #0E314A">
              {{ dados.media_diaria }}
            </div>
            <div class="text-caption grey--text">acessos por dia em média</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-card-text class="pa-3">
            <div class="text-caption text-uppercase grey--text">Tendência de Uso</div>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold" :style="{ color: tendencia.cor }">
                {{ tendencia.percentual > 0 ? '+' : '' }}{{ tendencia.percentual }}%
              </div>
              <v-icon class="ml-1" :color="tendencia.cor">{{ tendencia.icone }}</v-icon>
            </div>
            <div class="text-caption grey--text">
              {{ tendencia.label }} — vs. 7 dias anteriores
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="text-subtitle-2 font-weight-bold py-2">
            Acessos nos Últimos 30 Dias
            <v-spacer />
            <span class="text-caption font-weight-regular" :style="{ color: tendencia.cor }">
              <v-icon small :color="tendencia.cor">{{ tendencia.icone }}</v-icon>
              {{ tendencia.label }}
            </span>
          </v-card-title>
          <v-card-text class="pa-2">
            <apexchart
              v-if="chartSeries[0].data.length"
              :height="alturaGrafico"
              :options="chartOptions"
              :series="chartSeries"
            />
            <div v-else class="text-center grey--text py-8">
              Nenhum acesso registrado no período.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" md="7">
        <v-card outlined>
          <v-data-table
            :headers="headersUltimos"
            :items="dados.ultimos_acessos"
            :search="searchAcessos"
            :items-per-page="-1"
            dense
            fixed-header
            height="250"
            hide-default-footer
          >
            <template #top>
              <v-toolbar flat dense>
                <span class="text-subtitle-2 font-weight-bold">Últimos Acessos</span>
                <v-spacer />
                <v-text-field
                  v-model="searchAcessos"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  dense
                  outlined
                  style="max-width: 220px"
                  class="mr-2"
                />
                <v-btn text small color="success" @click="exportar('acessos')">
                  <v-icon left small>mdi-file-excel</v-icon> Exportar
                </v-btn>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="5">
        <v-card outlined>
          <v-data-table
            :headers="headersTop"
            :items="dados.top_usuarios"
            :search="searchAtivos"
            :items-per-page="-1"
            dense
            fixed-header
            height="250"
            hide-default-footer
          >
            <template #top>
              <v-toolbar flat dense>
                <span class="text-subtitle-2 font-weight-bold">Mais Ativos (30d)</span>
                <v-spacer />
                <v-text-field
                  v-model="searchAtivos"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  dense
                  outlined
                  style="max-width: 180px"
                  class="mr-2"
                />
                <v-btn text small color="success" @click="exportar('ativos')">
                  <v-icon left small>mdi-file-excel</v-icon> Exportar
                </v-btn>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AclAPI from "@/api/acl";
import api from "@/api/api";

export default {
  name: "PainelAdm",

  data() {
    return {
      dados: {
        licencas: 0,
        qtd_ativos: 0,
        acessos_hoje: 0,
        media_diaria: 0,
        acessos_por_dia: [],
        top_usuarios: [],
        ultimos_acessos: [],
      },

      tendencia: {
        percentual: 0,
        label: "estável",
        cor: "#9E9E9E",
        icone: "mdi-trending-neutral",
      },

      headersUltimos: [
        { text: "Usuário", value: "name", sortable: false },
        { text: "E-mail", value: "email", sortable: false },
        { text: "IP", value: "ip", sortable: false },
        { text: "Data/Hora", value: "data_acesso", sortable: false },
      ],

      headersTop: [
        { text: "Usuário", value: "name", sortable: false },
        { text: "Acessos", value: "total", sortable: false, align: "center" },
      ],

      chartOptions: {
        chart: { toolbar: { show: false }, background: "transparent", zoom: { enabled: false } },
        plotOptions: { bar: { borderRadius: 4, columnWidth: "60%" } },
        colors: ["#0E314A", "#F4511E"],
        stroke: { width: [0, 3], curve: "smooth" },
        markers: { size: [0, 0] },
        xaxis: { categories: [] },
        yaxis: { labels: { formatter: (v) => Math.round(v) } },
        dataLabels: { enabled: false },
        tooltip: {
          shared: true,
          y: { formatter: (v) => Math.round(v) + " acessos" },
        },
        legend: { show: true, position: "top" },
      },

      chartSeries: [{ name: "Acessos", type: "bar", data: [] }],

      searchAcessos: "",
      searchAtivos: "",
    };
  },

  computed: {
    alturaGrafico() {
      return this.$vuetify.breakpoint.xs ? 190 : 220;
    },
  },

  created() {
    this.carregar();
  },

  methods: {
    carregar() {
      const headers = this.Helpers.iniciarRequisicao();

      AclAPI.getPainelAdm(headers).then((response) => {
        const data = response.data;
        localStorage.setItem("token", data.token);

        this.dados = { ...this.dados, ...data };

        const valores = data.acessos_por_dia.map((r) => Number(r.total));
        const categorias = data.acessos_por_dia.map((r) => r.dia);

        this.tendencia = this.calcularTendencia(valores);

        this.chartOptions = {
          ...this.chartOptions,
          xaxis: { categories: categorias },
        };

        this.chartSeries = [
          { name: "Acessos", type: "bar", data: valores },
          { name: "Tendência", type: "line", data: this.regressaoLinear(valores) },
        ];
      });
    },

    calcularTendencia(valores) {
      const ultimos7 = valores.slice(-7);
      const anteriores7 = valores.slice(-14, -7);

      if (!anteriores7.length || !ultimos7.length) {
        return { percentual: 0, label: "sem dados suficientes", cor: "#9E9E9E", icone: "mdi-trending-neutral" };
      }

      const media = (arr) => arr.reduce((a, b) => a + b, 0) / arr.length;
      const mediaUlt = media(ultimos7);
      const mediaAnt = media(anteriores7);

      if (mediaAnt === 0) {
        return { percentual: 0, label: "sem dados suficientes", cor: "#9E9E9E", icone: "mdi-trending-neutral" };
      }

      const percentual = Math.round(((mediaUlt - mediaAnt) / mediaAnt) * 100);

      if (percentual > 5)  return { percentual, label: "em crescimento", cor: "#43A047", icone: "mdi-trending-up" };
      if (percentual < -5) return { percentual, label: "em queda", cor: "#E53935", icone: "mdi-trending-down" };
      return { percentual, label: "estável", cor: "#9E9E9E", icone: "mdi-trending-neutral" };
    },

    exportar(tabela) {
      const token = localStorage.getItem("token");
      const base = `${api.defaults.baseURL}/get_painel_adm_export?tabela=${tabela}&token=${token}`;
      const usuario = tabela === "acessos" ? this.searchAcessos : this.searchAtivos;
      const url = usuario.trim() ? `${base}&usuario=${encodeURIComponent(usuario.trim())}` : base;
      window.open(url, "_blank");
    },

    regressaoLinear(valores) {
      const n = valores.length;
      if (n < 2) return valores;

      const sumX  = valores.reduce((s, _, i) => s + i, 0);
      const sumY  = valores.reduce((s, v) => s + v, 0);
      const sumXY = valores.reduce((s, v, i) => s + i * v, 0);
      const sumXX = valores.reduce((s, _, i) => s + i * i, 0);

      const slope     = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
      const intercept = (sumY - slope * sumX) / n;

      return valores.map((_, i) => Math.round((slope * i + intercept) * 10) / 10);
    },
  },
};
</script>
